export const NOT_HAVE_VALUE_LABEL = "- -";
export const VALUE_SELECT_ALL = "-9999";
export const ALL_OPTIONS = { value: VALUE_SELECT_ALL, label: "-- Tất cả --" };

export const SUCCEED_VARIANT = "SucceedNotify";
export const ERROR_VARIANT = "ErrorServer";
export const WARNING_VARIANT = "WarningNotify";

export const DEBOUNCE_TIME_IN_MILLISECOND = 500;

export const PAGE_SIZE_OPTIONS = [20, 30, 50, 100, 500];
export const DEFAULT_PAGINATION = {
  page: 1,
  size: PAGE_SIZE_OPTIONS[0],
};

export const DEFAULT_PAGINATION_SKIP_TAKE = {
  skip: 0,
  take: PAGE_SIZE_OPTIONS[0],
};
export enum BooleanTypeEnum {
  False,
  True,
}
// Date, Time Format
export const YEAR_FORMAT = "YYYY";
export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";
export const DATE_TIME_SECOND_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const TIME_FORMAT = "HH:mm";

export const APP_TITLE = "LMS";

export const APP_PROGRESS_ID = "jsAppProgress";

export const IMAGE_RATIO = 16 / 9;
export const IMAGE_AVATAR_RATIO = 1 / 1;
export const VIDEO_RATIO = 99 / 56;
export const NEWS_RATIO = 1.43;

export const COOKIE_STORAGE = {
  User: "user",
  AccessToken: "accessToken",
  RefreshToken: "refreshToken",
  ExpiredTime: "expiredTime",
  Session: "session",
};
export const ACCEPT_FILE_VIDEO = {
  "video/mp4": [".mp4"],
};

export const MAX_SIZE_UPLOAD = 300 * 1024 * 1024;
export const ACCEPT_IMAGE = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg", ".jpg"],
  "image/gif": [".gif"],
};

export const ACCEPT_FILE_OFFICE = {
  "text/html": [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".pptx", ".ppt"],
};

export const ACCEPT_FILE_AUDIO = {
  "audio/mp3": [".mp3"],
};

export const ACCEPT_FILE_ZIP = {
  "application/zip": [".zip"],
};

export const ACCEPT_FILE = {
  ...ACCEPT_FILE_VIDEO,
  ...ACCEPT_IMAGE,
  ...ACCEPT_FILE_OFFICE,
  ...ACCEPT_FILE_AUDIO,
  ...ACCEPT_FILE_ZIP,
};

export const ACTIVE_APPROVED = [
  {
    label: "Chờ Duyệt",
    value: BooleanTypeEnum.False,
  },
  {
    label: "Đã duyệt",
    value: BooleanTypeEnum.True,
  },
];

export const ACTIVE_ON_GOING = [
  {
    label: "Đã kết thúc",
    value: BooleanTypeEnum.False,
  },
  {
    label: "Đang diễn ra",
    value: BooleanTypeEnum.True,
  },
  {
    label: "Chưa diễn ra",
    value: 2,
  },
];

export const ACTIVE_OPTIONS = [
  {
    label: "Hiển thị",
    value: BooleanTypeEnum.True,
  },
  {
    label: "Không hiển thị",
    value: BooleanTypeEnum.False,
  },
];

export const ACTIVE_OPTIONS_V2 = [
  {
    label: "Kích hoạt",
    value: BooleanTypeEnum.True,
  },
  {
    label: "Không kích hoạt",
    value: BooleanTypeEnum.False,
  },
];

export const YES_NO_LIST = [
  {
    label: "Có",
    value: BooleanTypeEnum.True,
  },
  {
    label: "Không",
    value: BooleanTypeEnum.False,
  },
];

export enum UserTypeEnum {
  Admin,
  Teacher,
  Student,
}

export const OPTION_TYPE_USER = [
  {
    value: UserTypeEnum.Admin,
    label: "Quản trị hệ thống",
  },
  {
    value: UserTypeEnum.Student,
    label: "Học sinh",
  },
  {
    value: UserTypeEnum.Teacher,
    label: "Giáo viên",
  },
];
